import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aff-logout-icon',
  templateUrl: './logout-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LogoutIconComponent {}
